import { connect } from "react-redux";
import Component from "./EditUser";

export default connect(
    null,
    ({ scp: { addUser, deleteUser }, alert: { silence } }) => ({ addUser, deleteUser ,silence })
)(Component);
